import React, { Fragment, useState } from 'react';
import {
  Button,
  Col,
  Container,
  Input,
  Label,
  Row,
} from 'reactstrap';

import ReactLoading from 'react-loading';
import axios from 'axios';
import zxcvbn from 'zxcvbn';
import { cfPath, azaStageazaPath } from '../../utilities/UrlPaths';

const requestLink = `${window.location.protocol}//${window.location.host}${window.location.pathname}`;

const EnterPassword = (props) => {
  const [passwordValue, setPasswordValue] = useState('');
  const [confirmValue, setConfirmValue] = useState('');
  const [progressClass, setProgressClass] = useState('');
  const [progressText, setProgressText] = useState('');
  const [passwordWarningText, setPasswordWarningText] = useState('');
  const [disabledButton, setDisabledButton] = useState(true);
  const [disabledCursor, setDisabledCursor] = useState('cursor-not-allowed');
  const [pwErrorMessage, setPwErrorMessage] = useState(false);
  const [pwErrorMessage2, setPwErrorMessage2] = useState(false);
  const [loading, setLoading] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const [expiredLink, setExpiredLink] = useState(false);

  const { jwtValue } = props;

  const validatePW = () => {
    let isValid = false;
    setPwErrorMessage(false);
    setPwErrorMessage2(false);
    if (passwordValue.length > 9) {
      const pwRegex = /^[a-zA-Z0-9()*_\-!#$%^&*.]{10,50}$/;
      if (passwordValue !== confirmValue) {
        setPwErrorMessage(true);
      } else if (!pwRegex.test(passwordValue)) {
        setPwErrorMessage2(true);
      } else {
        isValid = true;
      }
    }
    return isValid;
  };

  const submitNewpassword = async () => {
    const isValid = validatePW();
    if (isValid) {
      const apiUrl = `${azaStageazaPath()}/house/user/resetPassword`;
      const postBody = {
        jwt: jwtValue,
        newPassword: passwordValue,
      };
      try {
        setLoading(true);
        await axios.post(apiUrl, postBody, { headers: { 'Content-Type': 'application/json' } });
        setIsSuccess(true);
      } catch (err) {
        setExpiredLink(true);
        console.log(err);
      }
      setLoading(false);
    }
  };

  const parseWarningText = (warning, size) => {
    let warningText = '';

    if (warning.indexOf('similar') > -1 && warning.indexOf('common') > -1) {
      warningText = 'This is similar to a commonly used password. Please update.';
    } else if (warning.indexOf('common') > -1 && warning.indexOf('password') > -1) {
      warningText = 'This is a very common password. Please update.';
    } else if (warning.indexOf('names') > -1) {
      warningText = 'Passwords should not use names or surnames.';
    } else if (warning.indexOf('word by itself') > -1) {
      warningText = 'Passwords should not be a single word.';
    } else if (warning.indexOf('years') > -1 || warning.indexOf('dates') > -1) {
      warningText = 'Passwords should not use only years or dates.';
    } else if (warning.indexOf('sequences') > -1) {
      warningText = 'Passwords should not use sequences like "abc" or "6543".';
    } else if (warning.indexOf('repeats') > -1) {
      warningText = 'Passwords should not use repetitive phrases like "aaa" or "abcabcabc".';
    } else if (warning.indexOf('keys') > -1 || warning.indexOf('keyboard') > -1) {
      warningText = 'Passwords should not use straight rows of keys or keyboard patterns.';
    } else if (size < 10) {
      warningText = 'Password must be at least 10 characters.';
    } else if (size > 50) {
      warningText = 'Password cannot be more than 50 characters.';
    }

    return warningText;
  };

  const getMeterValues = (strength, size) => {
    let passwordStrengthVariant = 'danger';
    let passwordStrengthValue = 25;
    let passwordStrengthText = ' Weak';

    //  catch for length - short PW will always be weak
    if (size > 9) {
      switch (strength) {
        case 4:
          passwordStrengthVariant = 'success';
          passwordStrengthValue = 100;
          passwordStrengthText = ' Excellent';
          break;
        case 3:
          passwordStrengthVariant = 'info';
          passwordStrengthValue = 75;
          passwordStrengthText = ' Good';
          break;
        case 2:
          passwordStrengthVariant = 'warning';
          passwordStrengthValue = 50;
          passwordStrengthText = ' Fair';
          break;
        case 1:
        case 0:
        default:
          passwordStrengthVariant = 'danger';
          passwordStrengthValue = 25;
          passwordStrengthText = ' Weak';
          break;
      }
    }

    return {
      passwordStrengthVariant,
      passwordStrengthValue,
      passwordStrengthText,
    };
  };

  const getPasswordFeedback = (e, isPwField = true) => {
    let isDisabled = false;
    if (isPwField) {
      const pwFeedback = zxcvbn(e.target.value);
      const passwordStrength = pwFeedback.score;
      const passwordLength = e.target.value.length;
      const passwordWarning = parseWarningText(pwFeedback.feedback.warning.toLowerCase(), passwordLength);
      const passwordMeterValues = getMeterValues(passwordStrength, passwordLength);
      isDisabled = (passwordStrength < 2 || passwordLength < 10 || passwordLength > 50);
      setProgressClass(`bg-${passwordMeterValues.passwordStrengthVariant} w-${passwordMeterValues.passwordStrengthValue}`);
      setProgressText(passwordMeterValues.passwordStrengthText);
      setPasswordWarningText(passwordWarning);
    }
    const isValidInput = validatePW();
    setDisabledButton(isDisabled || !isValidInput);
    setDisabledCursor((isDisabled || !isValidInput) ? 'cursor-not-allowed' : '');
  };

  if (loading) {
    return <ReactLoading className="loading-spinner" type="spin" color="black" />;
  }
  return (
    <Container className="mt-4 pt-2 pb-5">
      <Row>
        <Col xs={12} md={8} lg={6}>
          <h1>Reset password</h1>
          {isSuccess
            && (
              <div className="mt-4">
                Your password has been successfully reset.  You can now use your new password to <a href={cfPath()}>log into your account.</a>
              </div>
            )}
          {expiredLink
            && (
              <div className="mt-4">
                There was a problem submitting your request. This was most likely caused by clicking on an expired link.
                <a className="ml-2" href={requestLink}>Request a new link</a>
              </div>
            )}
          {!isSuccess && !expiredLink
            && (
              <Fragment>
                <div className="mt-4">
                  <Label htmlFor="password">
                    <span className="font-weight-bold">Password*</span> (must be 10-50 characters)
                  </Label>
                  <Input
                    type="password"
                    className="form-control"
                    name="password"
                    title="Password"
                    value={passwordValue}
                    onChange={e => setPasswordValue(e.target.value)}
                    onKeyUp={e => getPasswordFeedback(e)}
                    onFocus={() => {
                      setPwErrorMessage(false);
                      setPwErrorMessage2(false);
                    }}
                  />
                </div>
                <div className="mt-4">
                  <Label htmlFor="confirmPassword" className="font-weight-bold">Confirm Password*</Label>
                  <Input
                    type="password"
                    className="form-control"
                    name="confirmPassword"
                    title="Confirm Password"
                    value={confirmValue}
                    onChange={e => setConfirmValue(e.target.value)}
                    onKeyUp={e => getPasswordFeedback(e, false)}
                    onFocus={() => setPwErrorMessage(false)}
                  />
                </div>
                <div className="my-4">
                  <div>
                    <span id="pwStrengthTitle">Password Strength</span>:
                    <span id="pwStrengthValue">{progressText}</span>

                  </div>
                  <div className="progress">
                    <div
                      id="progressBar"
                      className={`progress-bar ${progressClass}`}
                      role="progressbar"
                      aria-valuenow="0"
                      aria-valuemin="0"
                      aria-valuemax="100"
                      aria-label="Password strength meter"
                    >&nbsp;
                    </div>
                  </div>
                  <div id="pwWarningText" className="my-2 password-error">
                    {passwordWarningText}
                  </div>
                  {pwErrorMessage
                    && (
                      <div className="password-error my-2">
                        Passwords must match
                      </div>
                    )}
                  {pwErrorMessage2
                    && (
                      <div className="password-error my-2">
                        Passwords can only contain basic Latin characters, numbers, and symbols (*_-!#$%^&*.)
                      </div>
                    )}
                </div>
                <div className="mt-4">
                  <Button
                    onClick={() => submitNewpassword()}
                    disabled={disabledButton}
                    className={`w-50 ${disabledCursor}`}
                    color="primary"
                  >
                    Reset Password
                  </Button>
                </div>
              </Fragment>
            )}
        </Col>
      </Row>
    </Container>
  );
};

export default EnterPassword;
